import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import Layout from '../components/Layout';
import './SettingsPage.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SettingsPage = () => {
  const { user, sessionToken, refreshUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  
  const [profileData, setProfileData] = useState({
    dob_month: '',
    dob_day: ''
  });

  useEffect(() => {
    if (user) {
      setProfileData({
        dob_month: user.dob_month || '',
        dob_day: user.dob_day || ''
      });
    }
  }, [user]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSaveDOB = async () => {
    try {
      setLoading(true);
      setError('');
      setSuccess('');

      const updateData = {
        dob_month: profileData.dob_month ? parseInt(profileData.dob_month) : null,
        dob_day: profileData.dob_day ? parseInt(profileData.dob_day) : null
      };

      await axios.put(
        `${API}/auth/profile`,
        updateData,
        {
          headers: {
            Authorization: `Bearer ${sessionToken}`,
            'Content-Type': 'application/json'
          }
        }
      );

      await refreshUser();
      setSuccess('Date of birth updated successfully!');
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to update');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="settings-page">
        <div className="settings-header">
          <h1>Settings</h1>
          <p>Manage your application settings and preferences</p>
        </div>

        <div className="settings-content">
          {/* Personal Information Section */}
          <div className="settings-section">
            <h2>👤 Personal Information</h2>
            
            {success && <div className="success-message">{success}</div>}
            {error && <div className="error-message">{error}</div>}
            
            <div className="setting-item">
              <div className="setting-info">
                <h3>Date of Birth</h3>
                <p>Your birth month and day (year not required)</p>
              </div>
              <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                <select
                  name="dob_month"
                  value={profileData.dob_month}
                  onChange={handleInputChange}
                  className="dob-select"
                >
                  <option value="">Month</option>
                  <option value="1">January</option>
                  <option value="2">February</option>
                  <option value="3">March</option>
                  <option value="4">April</option>
                  <option value="5">May</option>
                  <option value="6">June</option>
                  <option value="7">July</option>
                  <option value="8">August</option>
                  <option value="9">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </select>
                <input
                  type="number"
                  name="dob_day"
                  value={profileData.dob_day}
                  onChange={handleInputChange}
                  placeholder="Day"
                  min="1"
                  max="31"
                  className="dob-input"
                />
                <button 
                  className="btn-save-dob"
                  onClick={handleSaveDOB}
                  disabled={loading}
                >
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>

          <div className="settings-section">
            <h2>🔔 Notifications</h2>
            <div className="setting-item">
              <div className="setting-info">
                <h3>Email Notifications</h3>
                <p>Receive updates about your collections and credits</p>
              </div>
              <label className="toggle">
                <input type="checkbox" defaultChecked />
                <span className="toggle-slider"></span>
              </label>
            </div>
            <div className="setting-item">
              <div className="setting-info">
                <h3>New Collections Alerts</h3>
                <p>Get notified when new seasonal collections are available</p>
              </div>
              <label className="toggle">
                <input type="checkbox" defaultChecked />
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>

          <div className="settings-section">
            <h2>🎨 Appearance</h2>
            <div className="setting-item">
              <div className="setting-info">
                <h3>Theme</h3>
                <p>Choose your preferred theme</p>
              </div>
              <select className="theme-select">
                <option>Light Mode</option>
                <option>Dark Mode (Coming Soon)</option>
              </select>
            </div>
          </div>

          <div className="settings-section">
            <h2>🔒 Privacy</h2>
            <div className="setting-item">
              <div className="setting-info">
                <h3>Profile Visibility</h3>
                <p>Control who can see your profile</p>
              </div>
              <select className="privacy-select">
                <option>Private</option>
                <option>Public (Coming Soon)</option>
              </select>
            </div>
          </div>

          <div className="settings-section danger-section">
            <h2>⚠️ Danger Zone</h2>
            <div className="setting-item">
              <div className="setting-info">
                <h3>Delete Account</h3>
                <p>Permanently delete your account and all data</p>
              </div>
              <button className="btn-danger">Delete Account</button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SettingsPage;